export let expireTime = 0;
export const changeExpireTime = (time) => {
  expireTime = time;
};
